import * as React from 'react';
import { addPrecondition } from 'pos/common';

import { Preconditions } from 'core/infrastructure-next';
import { Res, Permission, PaymentMethodBalanceDTO } from 'core/api';
import * as UI from 'core/ui';
import { ActionButtonDefinition, DialogIcon, PosScreenClassComponent, ScreenSize } from 'pos/ui';
import * as Images from 'pos/Images';
import { Button, Col, Cols } from 'core/ui';
import showDiscrepancy from './showDiscrepancy';
import { Modal } from 'core/ui-next/modal';

type Props = {
	balances: PaymentMethodBalanceDTO[]
} & Modal.Actions<string>

type State = {
	incident: string
}

class GetBalanceIncident extends PosScreenClassComponent<Props, State> {

	private form = React.createRef<UI.Form<State>>();
	private txtIncident = React.createRef<UI.TextBox<State>>();

	createInitialState(_props: Props): Nullable<State> {
		return { incident: Res.Msg.MSG_UNKNOWN_CLOSE_DAY_INCIDENT_REASON() };
	}

	onComponentDidMount(): void {
		this.txtIncident.current!.activate();
	}

	onComponentWillUnmount(): void {
	}

	protected useKeypad(): boolean {
		return false;
	}

	protected getScreenId(): string {
		return 'GET_BALANCE_INCIDENT';
	}

	protected getTitle(): string {
		return Res.Web.GET_BALANCE_INCIDENT();
	}

	protected getImage(): string | SvgIcon {
		return Images.BalanceIncident;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return this.okCancelButtons({ onOK: this.onOK });
	}

	protected getSize(): ScreenSize {
		return 'small';
	}

	onOK = async () => {
		const updated = await this.form.current!.updateModel();
		if (updated)
			this.close(this.state.incident);
	};

	onShowDiscrepancy = async () => await showDiscrepancy(this.props.balances);

	protected getContent(): React.ReactNode {
		const { Form, TextBox } = UI.controlsFor<State>();

		return <Form small ref={this.form} model={this.state}>
			<DialogIcon src={Images.BalanceIncident} />
			<p className='text-center m-t-sm text-14'>
				{Res.Web.GET_BALANCE_INCIDENT_INFO_LBL()}
			</p>
			<Cols className='m-t-lg'>
				<Col width='*' className='text-center'>{Res.Web.GET_BALANCE_INCIDENT_INCIDENT_LBL()}</Col>
			</Cols>
			<Cols>
				<Col width='*'>
					<TextBox ref={this.txtIncident} className='text-center' linkTo={x => x.incident} required onKeyDown={UI.whenEnterKey(this.onOK)} />
				</Col>
			</Cols>
			<p className='m-t-xl text-center'>
				<Button buttonStyle='info' outline onClick={this.onShowDiscrepancy} tabIndex={-1}>
					{Res.Web.GET_BALANCE_INCIDENT_SHOW_DISCREPANCY()}
				</Button>
			</p>
		</Form>;
	}
}

async function getBalanceIncident(balances: PaymentMethodBalanceDTO[]): Promise<Result<string>> {
	return Modal.show(GetBalanceIncident, { balances: balances });
}

export default addPrecondition(Preconditions.ensure(Permission.Pos_RegisterBalanceIncident), getBalanceIncident);
